import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/es'  
import 'react-app-polyfill/ie9'  
import 'react-app-polyfill/stable'
import 'antd/dist/antd.less';
import './index.less';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/locale/zh_CN';

// global.httpUrl = "http://192.168.1.60:8083";  //java本地
global.httpUrl="https://layer.cqczh.com.cn/admin/";  //php线上
global.imgUrl='https://layer.cqczh.com.cn/'//图片上传域名

ReactDOM.render(
	<ConfigProvider locale={locale}>
		<App />
	</ConfigProvider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// reportWebVitals(console.log);
